import React from 'react';
import {Message} from 'epic-diesel-common';
import PropTypes from 'prop-types';
import Input from 'epic-diesel-form/src/components/form/Input';
import {getMessage} from '../../common/Message';
import Select from 'epic-diesel-form/src/components/form/Select';
import Languages from '../../../constants/Languages';
import signupStyles from '../../../pages/signup/SignUp.pcss';
import styles from './RegionAndLanguageSection.pcss';

import Countries, {states} from 'epic-diesel-form/src/constants/Countries';
import getInfluencersFlowSchema from '../../../data/InfluencersFlowSchema';

export default class RegionAndLanguageSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        form: PropTypes.object,
        trigger: PropTypes.func
    };

    static defaultProps = {};

    onChange = event => {
        const {name, value} = event.target;
        this.props.trigger(name, value);
    };

    getLanguages = () => {
        const {messages} = this.props;
        const returnVal = [];

        returnVal.push({
            value: '',
            label: `${getMessage(messages, 'epic.affiliate.common.select_language')} *`
        });

        for (let i = 0; i < Languages.length; i++) {
            returnVal.push(
                //{value: Languages[i].value, label: getMessage(messages, `epic.affiliate.common.${Languages[i].value.replace('-', '_')}`)}
                {value: Languages[i].value, label: Languages[i].label}
            );
        }

        return returnVal;
    };

    getStates = () => {
        const {messages} = this.props;

        const returnVal = [
            {
                value: '',
                label: `${getMessage(
                    messages,
                    'epic.affiliate.signup.location.state_or_province'
                )} *`
            }
        ].concat(states);

        return returnVal;
    };

    render() {
        const {form, trigger, messages} = this.props;

        const taxInfoSchema = getInfluencersFlowSchema(getMessage, messages).taxInfo;
        const signUpInfoSchema = getInfluencersFlowSchema(getMessage, messages).signupInfo;
        const isForeign = form.country !== 'US';

        return (
            <div className={signupStyles.header}>
                <h2>
                    <Message code="epic.affiliate.signup.region.header" />
                    {' *'}
                </h2>
                <p>
                    <Message code="epic.affiliate.signup.region.text" />
                </p>

                <div className={styles.content}>
                    <div>
                        <Select
                            required
                            className={styles.languages}
                            name={signUpInfoSchema.language.identifier}
                            placeholder={signUpInfoSchema.language.display.text}
                            value={form.language}
                            onChange={trigger}
                            options={this.getLanguages()}
                        />
                    </div>

                    <div>
                        <Select
                            required
                            name={taxInfoSchema.country.identifier}
                            value={form.country}
                            onChange={trigger}
                            options={Countries}
                            validationErrors={taxInfoSchema.country.validationMessages}
                        />
                    </div>

                    <div className={styles.stateCityContainer}>
                        {!isForeign && (
                            <div className={styles.stateContainer}>
                                <Select
                                    name={taxInfoSchema.state.identifier}
                                    value={form.state || ''}
                                    required={!isForeign}
                                    placeholder={`${taxInfoSchema.state.display.text} *`}
                                    validations={taxInfoSchema.state.validations}
                                    validationErrors={taxInfoSchema.state.validationMessages}
                                    onChange={trigger}
                                    options={this.getStates()}
                                />
                            </div>
                        )}

                        {isForeign && (
                            <div className={styles.stateContainer}>
                                <Input
                                    name={taxInfoSchema.region.identifier}
                                    value={form.state}
                                    placeholder={taxInfoSchema.region.display.text}
                                    validations={taxInfoSchema.region.validations}
                                    validationErrors={taxInfoSchema.region.validationMessages}
                                    required={true}
                                    onChange={this.onChange}
                                />
                            </div>
                        )}

                        <div className={styles.cityContainer}>
                            <Input
                                name={taxInfoSchema.city.identifier}
                                value={form.city}
                                placeholder={taxInfoSchema.city.display.text}
                                validations={taxInfoSchema.city.validations}
                                validationErrors={taxInfoSchema.city.validationMessages}
                                required={true}
                                onChange={this.onChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
